require("./AlternativeFundView.scss");

const React = require("react");
const PropTypes = require("prop-types");
const { connect } = require("react-redux");

const { FormattedText, formatText } = require("core/i18n").i18n;

const { OKCover } = require("commonsComponents/OKCover");
const { LoadingSection } = require("commonsComponents/loadingSection");
const { OKHeaderSubPage } = require("commonsComponents/OKHeaderSubPage");
const MyFundInfo = require("../MyFundInfo/MyFundInfo");
const MyFundsNavigator = require("../MyFundsNavigator/MyFundsNavigator");
const { selectFund } = require("../../selectors/fundsSelectors");
const Documentation = require("../../containers/Documentation");
const AlternativeFundBox = require("../AlternativeFundBox");
const { OKButton } = require("components/commons/OKButton/OKButton");
const WizardError = require("components/commons/wizardError/wizardError");
const ComplexityAlert = require("../../components/complexityAlert");
// @ constants
const {
    MYPROFILE_BROKER_EXPLORE_URL,
    LEGAL_DOCUMENTS_TYPES,
} = require("../../constants");

// @actions
const { fetched: fundFetchRequested } = require("../../actions/funds");
const {
    closed: glossaryClosed,
    opened: glossaryOpened,
} = require("actions/glossary");
const {
    searchSpecificIsin: searchDataWithIsin,
} = require("actions/brokerProductAdvancedSearch");

class AlternativeFundView extends React.Component {
    constructor(props) {
        super(props);

        this.breadcrumbConfig = this.breadcrumbConfig.bind(this);
        this.getDocumentsFunds = this.getDocumentsFunds.bind(this);
        this.getSubcategory = this.getSubcategory.bind(this);
    }

    componentDidMount() {
        const {
            fetchFund,
            fund,
            match: {
                params: { id, idType },
            },
            originCountry,
            isPublicUser,
            searchData,
            loading,
        } = this.props;
        if (!fund && !loading) {
            fetchFund({
                id,
                idType,
                originCountry,
                isPublicUser,
                isAlternativeFund: true,
            });
            searchData(id);
        }
        const taggingData = {
            event_name: "view",
            pageName: `ficha fondo alternativo/${fund && fund.name}`,
            serviceType: "productInformation",
            interactionType: "screen"       
        }
       fund && window && window.utag && window.utag.view && window.utag.view(taggingData);
        
    }

    componentDidUpdate(prevProps) {
        const {
            fetchFund,
            match: {
                params: { id, idType },
            },
            originCountry,
            isPublicUser,
        } = this.props;
        if (this.props.match.params.id !== prevProps.match.params.id) {
            fetchFund({ id, idType, originCountry, isPublicUser });
        }
    }

    breadcrumbConfig() {
        const { fund, catalogueDetails, contextUriFundsLandingView } =
            this.props;
        const config = [
            {
                text: formatText(
                    "brokerAlternativeFundsCard-breadcrumb_category"
                ),
                url: contextUriFundsLandingView,
            },
        ];
        if (fund && catalogueDetails) {
            config.push({ text: catalogueDetails.name, url: "" });
        }
        return config;
    }

    getDocumentsFunds(fund) {
    const { PROSPECTUS, INFORME_SEMESTRAL, DFI, PRESENTATION } = LEGAL_DOCUMENTS_TYPES;
        let ArrayDocuments = [];
        const { immFeatureFlags } = this.props;

        const showPurchaseProspectusReport = immFeatureFlags.get(
            "wealth_funds_show_purchase_prospectus_document"
        );
        const showProspectusDocumentOnNationalFunds = immFeatureFlags.get(
            "wealth_funds_show_prospectus_document_national_funds"
        );
        const showPresentationDocument = immFeatureFlags.get(
            "wealth_funds_show_fund_presentation_document"
        );
        const showRecomendationReport = immFeatureFlags.get(
            "wealth_funds_show_recommendation_report_document"
        );
        const showRiskAssumptionDocument = immFeatureFlags.get(
            "wealth_funds_show_risk_assumption_document"
        );

        const showProspectus =
            showPurchaseProspectusReport ||
            showProspectusDocumentOnNationalFunds;

        if (fund !== undefined) {
            try {
                if (showPresentationDocument) {
                    ArrayDocuments.push({
                        titlePDF: "brokerAlternativeFundsCard-presentation",
                        link: fund.alternativeDocuments[PRESENTATION],
                    });
                }

                if (showRiskAssumptionDocument) {
                    ArrayDocuments.push({
                        titlePDF: "brokerAlternativeFundsCard-dfiDocument",
                        link: fund.alternativeDocuments[DFI],
                    });
                }

                if (showRecomendationReport) {
                    ArrayDocuments.push({
                        titlePDF: "brokerAlternativeFundsCard-economicReport",
                        link: fund.alternativeDocuments[INFORME_SEMESTRAL],
                    });
                }

                if (showProspectus) {
                    ArrayDocuments.push({
                        titlePDF: "brokerAlternativeFundsCard-prospectus",
                        link: fund.alternativeDocuments[PROSPECTUS],
                    });
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error("Could not get documents: " + err);
            }
        }

        return ArrayDocuments;
    }

    getSubcategory(id, subCategories) {
        const subCategoryName =
            id && subCategories
                ? subCategories.filter(
                      (category) => category.id === id.toString()
                  )
                : null;

        if (subCategoryName && subCategoryName[0]) {
            const identifier = subCategoryName[0].id;
            return formatText(`fundsSubCategory-key${identifier}`);
        }

        return null;
    }

    buildErrorState() {
        const mainButton = {
            label: formatText("broker-errorGoToMyWallet"),
            url: "/myprofile/broker",
        };
        const errorMessage = formatText("broker-errorPrimaryMessage");
        return (
            <div className="alternative-fund-view__error-state">
                <WizardError
                    errorMessage={formatText("broker-errorTitle")}
                    mainButton={mainButton}
                    customClassName="broker-errors-view__body"
                >
                    <div>
                        <div className="broker-errors-view__primary-message">
                            {errorMessage}
                        </div>
                        <div>
                            <FormattedText
                                value="broker-errorSecondaryMessage"
                                injectedStrings={[
                                    formatText("emails-investments"),
                                ]}
                            />
                        </div>
                    </div>
                </WizardError>
            </div>
        );
    }

    buldSuccessState() {
        const {
            fund,
            match,
            UserFundBox,
            onlyOneFundWithSameIsin,
            location,
            catalogueDetails,
        } = this.props;
        return (
            <section>
                <div className="grid-view__body">
                    <div className="container">
                        <ComplexityAlert />
                        <div className="row broker__header">
                            <div className="col-md-8 col-xs-12 alternative__fund__box">
                                {fund && catalogueDetails ? (
                                    <AlternativeFundBox
                                        fund={fund}
                                        catalogueDetails={catalogueDetails}
                                    />
                                ) : (
                                    <LoadingSection />
                                )}
                            </div>
                            <div className="col-md-4 col-xs-12 header__purse">
                                <UserFundBox
                                    fund={fund}
                                    match={match}
                                    location={location}
                                    onlyOneFundWithSameIsin={
                                        onlyOneFundWithSameIsin
                                    }
                                    isAlternativeFund
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container wrapper--tabs">
                    <div className="wrapper--tabs">
                        {fund ? (
                            <Documentation
                                fund={this.getDocumentsFunds(fund)}
                            />
                        ) : (
                            <LoadingSection />
                        )}
                    </div>
                </div>
            </section>
        );
    }

    render() {
        const {
            fund,
            assetsCategory,
            subCategories,
            minimumDetails,
            loading,
            error,
            contextUriFundsLandingView,
            redirectToExplore,
            isPublicUser,
        } = this.props;

        if (fund !== undefined && fund.custom) {
            fund.subCategory = this.getSubcategory(
                fund.custom.customCategoryId,
                subCategories
            );
            fund.minimumDetails = minimumDetails && minimumDetails[0];
            fund.category = assetsCategory;
        }
        const content =
            !loading && error
                ? this.buildErrorState()
                : this.buldSuccessState();
        const productExplorerURL =  isPublicUser ? contextUriFundsLandingView : MYPROFILE_BROKER_EXPLORE_URL
                       
        return (
            <div className="alternative-fund-view">
                <div className="container__fluid account-movements--header-identifier">
                    <div className="wrapper__header--funds row">
                        <OKCover
                            size={"medium"}
                            section="broker"
                            customClass="col-xs-12"
                        >
                            <div className="col-md-12 col-xs-12 alternative-fund-view__title">
                                <OKHeaderSubPage
                                    breadcrumbConfig={this.breadcrumbConfig()}
                                    finalTitle={formatText(
                                        "brokerAlternativeFundsCard-title"
                                    )}
                                    isNotMainTitle
                                ></OKHeaderSubPage>
                                <OKButton
                                    inverse={true}
                                    modifier="ghost"
                                    to={productExplorerURL}
                                    onClick={() => redirectToExplore ? redirectToExplore() : () => {}}
                                >
                                    <FormattedText value="broker-goToAdvancedSearch" />
                                </OKButton>
                            </div>
                        </OKCover>
                    </div>
                </div>
                {content}
            </div>
        );
    }
}

AlternativeFundView.propTypes = {
    assetsCategory: PropTypes.string.isRequired,
    closeGlossary: PropTypes.func.isRequired,
    originCountry: PropTypes.string.isRequired,
    isPublicUser: PropTypes.bool.isRequired,
    contextUriFundsLandingView: PropTypes.string,
    fetchFund: PropTypes.func.isRequired,
    fund: PropTypes.object,
    openGlossary: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    searchData: PropTypes.func.isRequired,
    user: PropTypes.object,
    minimumDetails: PropTypes.array,
    memoriesURL: PropTypes.string,
    onlyOneFundWithSameIsin: PropTypes.string.isRequired,
    catalogueDetails: PropTypes.object,
    immFeatureFlags: PropTypes.object.isRequired,
    subCategories: PropTypes.array,
    loading: PropTypes.bool,
    error: PropTypes.bool,
    UserFundBox: PropTypes.func,
    redirectToExplore: PropTypes.func,
};

AlternativeFundView.defaultProps = {
    contextUriFundsLandingView: "/myprofile/broker/alternative-funds",
    AssetsNavigator: MyFundsNavigator,
    UserFundBox: MyFundInfo,
    isPublicUser: false,
    publicExploreURL: "",
};

const theOnlyOne = (brokerMyInvestments, routeParams) => {
    const stocks = brokerMyInvestments.getIn(["products", "funds", "stocks"]);
    if (!stocks || stocks.size === 0) return "";

    const { id } = routeParams;
    const filter = stocks.filter((stock) => stock.get("isin") == id);
    const contractNumber =
        !!filter && filter.size === 1
            ? filter.getIn([0, "numerodecontrato"], "")
            : "";
    return contractNumber;
};

const mapStateToProps = (state, props) => ({
    fund: selectFund(state, props),
    onlyOneFundWithSameIsin: theOnlyOne(
        state.brokerMyInvestments,
        props.match.params
    ),
    originCountry: state.profile.get("originCountry"),
    assetsCategory: state.brokerInvestmentFundView.assetsCategory,
    subCategories: state.brokerInvestmentFundView.subCategories,
    minimumDetails: state.brokerInvestmentFundView.minimumDetails,
    catalogueDetails: state.brokerInvestmentFundView.catalogueDetails,
    loading: state.brokerInvestmentFundView.loading,
    error: state.brokerInvestmentFundView.error,
    memoriesURL: state.globalVariables.getIn([
        "variables",
        "parameters",
        "memories",
        "memories",
    ]),
    immFeatureFlags: state.flagBasedFeatures,
});

const mapDispatchToProps = (dispatch) => ({
    closeGlossary: () => dispatch(glossaryClosed()),
    fetchFund: ({
        idType,
        id,
        originCountry,
        isPublicUser,
        isAlternativeFund,
    }) =>
        dispatch(
            fundFetchRequested({
                idType,
                id,
                originCountry,
                isPublicUser,
                isAlternativeFund,
            })
        ),
    openGlossary: (query) => dispatch(glossaryOpened({ query })),
    searchData: (isin) => dispatch(searchDataWithIsin(isin)),
});

module.exports = connect(
    mapStateToProps,
    mapDispatchToProps
)(AlternativeFundView);
